import React, { PropsWithChildren, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './BazaarvoiceReview.css';

interface IBazaarvoicereviewProps extends MappedComponentProperties {
    productId?: string;
    componentId?: string;
    productMeta?: string;
    addBorder?: string;
    stagingScript? : boolean; //toggles between staging and production

}

export const BazaarvoicereviewEditConfig = {
    emptyLabel: 'BazaarvoiceReview',
    isEmpty: () => {
        return true;
    },

};

const BazaarvoiceReview = (props: PropsWithChildren<IBazaarvoicereviewProps>): JSX.Element => {
    if (props.isInEditor && props.productId) {
        BazaarvoicereviewEditConfig.emptyLabel = 'Bazaarvoice Component. This placeholder text is visible in Edit mode only.';
    }
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://apps.bazaarvoice.com/deployments/creditone/main_site/${props.stagingScript ? 'staging' : 'production'}/en_US/bv.js`;
        script.id = 'bvAPI';
        script.async = true;
        document.body.appendChild(script);
    }, []);
    return (
        <div id='bazaarvoice-review' className={'BazaarvoiceReview'}>
            <div className={`BazaarvoiceReview__row ${props.addBorder}`}>
                <div data-bv-show='rating_summary' data-bv-product-id={`${props.productId}`} data-bv-seo='false'></div>
                <div data-bv-show='reviews' data-bv-product-id={`${props.productId}`}></div>
                <div data-bv-show='questions' data-bv-product-id={`${props.productId}`}></div>
            </div>
        </div>
    );
};

export default BazaarvoiceReview;
